import { formatDate, StatusBadge, type StatusBadgeProps } from '@berky/ui'

import type { FeedbackStatus } from '../types'

const tones: Record<FeedbackStatus, StatusBadgeProps['tone']> = {
  Neu: 'info',
  'In Bearbeitung': 'warning',
  Zurückgestellt: 'neutral',
  Erledigt: 'success',
  Abgelehnt: 'error',
}

export function FeedbackStatusBadge({
  status,
  zurueckgestelltBis,
}: {
  status: FeedbackStatus
  zurueckgestelltBis?: string | null
}) {
  return (
    <StatusBadge tone={tones[status]}>
      {status === 'Zurückgestellt' && zurueckgestelltBis
        ? `${status} (${formatDate(zurueckgestelltBis)})`
        : status}
    </StatusBadge>
  )
}
